import { useEffect, useState } from 'react'

const useDateFormat = (timeZone?: string) => {
  const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  if (!timeZone) {
    timeZone = defaultTimeZone
  }

  const shortDateIsoFormatter = Intl.DateTimeFormat('sv', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone })
  const shortTimeIsoFormatter = Intl.DateTimeFormat('sv', { hour: 'numeric', minute: '2-digit', timeZone })

  /**
   * @param date The date to format
   * @returns a string that looks like `2022-03-26`
   */
  const dateToISODateKey = (date: Date) => shortDateIsoFormatter.format(date)

  /**
   * @param date The date to format
   * @returns a string that looks like `15:23`
   */
  const dateTo24hrDisplayTime = (date: Date) => shortTimeIsoFormatter.format(date)

  /**
   * This useEffect has the purpose of triggering a re-render when the time zone of the system changes
   */
  const [systemTimeZone, setSystemTimeZone] = useState<string>(defaultTimeZone)
  useEffect(() => {
    const checkTimezone = () => {
      const currentTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone
      if (systemTimeZone !== currentTimezone) {
        setSystemTimeZone(currentTimezone)
      }
    }
    const interval = setInterval(checkTimezone, 1000)
    return () => clearInterval(interval)
  }, [systemTimeZone])

  return { dateTo24hrDisplayTime, dateToISODateKey }
}

export { useDateFormat }
